export default "__VITE_ASSET__D$la_YLh__"